import MediaCenterSearch from "./media-center";
import AwardsSearch from "./awards-search";
import AlumniBusinessSearch from "./alumni-business-search";
import StaffDirectorySearch from "./staff-directory-search";
import { SearchInitConfig, SearchClientConfig} from "../search";

enum SearchTypes {
    MediaCenter = "MediaCenter",
    EntranceAwards = "EntranceAwards",
    BusinessDirectory = "BusinessDirectory",
    StaffDirectory = "StaffDirectory"
}

class LandingSearchManager {
    private rootComponent: HTMLElement;
    private searchType: SearchTypes;
    private clientConfig: SearchClientConfig;
    
    public search: MediaCenterSearch | AwardsSearch | AlumniBusinessSearch | StaffDirectorySearch;

    constructor(clientConfig: SearchClientConfig) {
        this.clientConfig = clientConfig;
    }

    setRootComponent(component: HTMLElement) {
        this.rootComponent = component;
        this.searchType = SearchTypes[this.rootComponent.dataset.searchType];
        if (!this.searchType) {
            this.searchType = SearchTypes.MediaCenter;
        }
    }

    start(facets: Array<any>) {
        // just make a skelton config for all the landing pages.
        const defaultInitConfig: SearchInitConfig = {
                searchBoxId: "<landing-search-id>",
                resultContainerId: "<landing-search-container-id>",
                queryName: "q",
                textboxPlaceholder: "Enter your search term here",
                activeTemplate: "list",
                templates: {}
        };

        if (this.searchType == SearchTypes.MediaCenter) {
            // media centre
            this.search = new MediaCenterSearch(this.rootComponent, this.clientConfig, defaultInitConfig);
            this.search.onLoad(facets);       
        } else if (this.searchType == SearchTypes.EntranceAwards) {
            // entrance awards
            this.search = new AwardsSearch(this.rootComponent, this.clientConfig, defaultInitConfig);
            this.search.onLoad([]);

        } else if (this.searchType == SearchTypes.BusinessDirectory) {
            // business directory
            this.search = new AlumniBusinessSearch(this.rootComponent, this.clientConfig, defaultInitConfig);
            this.search.onLoad([]);
        }
        else if(this.searchType == SearchTypes.StaffDirectory){
            // staff directory
            this.search = new StaffDirectorySearch(this.rootComponent, this.clientConfig, defaultInitConfig);
            this.search.onLoad(facets);
        }
    }
}
export default LandingSearchManager;